import { CanvasState } from 'src/app/model/canvas-state';

export const CANVAS_STATES: CanvasState = 
    {
        staticName: null,
        type: null,
        active: false
    }